import { atom } from 'jotai'
import type { IVALaunchPointName } from 'typings/custom'
import type { Modals } from './typings'

type PendingAccountServicesLaunch =
  | {
      type: 'modal'
      modal: Modals
      triggerId: string
    }
  | {
      type: 'iva'
      pointOfNeed: IVALaunchPointName
      accountId: string
    }

const initialPendingAccountServicesLaunch: PendingAccountServicesLaunch | null =
  null

const pendingAccountServicesLaunchAtom = atom(
  initialPendingAccountServicesLaunch
)

export default pendingAccountServicesLaunchAtom
